import {createStyles} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import classnames from 'classnames'
import {Colors} from 'components/common/useBaseStyle'
import Text, {TextProps} from 'components/Text'
import React, {ReactNodeArray} from 'react'

const useSubTitleStyles = makeStyles(
  createStyles({
    root: {
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
    },

    headElement: {
      width: '100%',
      display: 'flex',
      marginBottom: 40,
    },
    numberElement: {
      display: 'flex',
      width: '38px',
      height: '42px',
      padding: '7px 10px 0px 10px',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: '10px',
      flexShrink: 0,
      borderRadius: '0px 10px',
      background: '#2E4D6F',
      '& p': {
        color: '#FFF',
        fontSize: '22px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '100%',
      },
    },
    textElement: {
      display: 'flex',
      height: '42px',
      padding: '7px 0px 0px 12px',
      alignItems: 'flex-start',
      gap: '10px',
      flex: '1 0 0',
      borderBottom: '2px solid #2E4D6F',
      color: '#2E4D6F',
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '100%',
      letterSpacing: '-0.66px',
    },
  }),
)

export type SubTitleBaseProps = {
  className?: string
  buttons?: ReactNodeArray
  number: string
}

type SubtitleProps = Omit<TextProps<'h3'>, 'typography' | 'as'> &
  SubTitleBaseProps

export default function ReportSubtitleV1({
  className,
  children,
  buttons = [],
  number,
  ...props
}: SubtitleProps) {
  const classes = useSubTitleStyles()

  const classNames = classnames({
    [classes.root]: true,
    // @ts-ignore
    [className]: className !== undefined,
  })

  return (
    <div className={classNames}>
      <div className={classes.headElement}>
        <div className={classes.numberElement}>
          <p>{number}</p>
        </div>
        <div className={classes.textElement}> {children}</div>
      </div>
    </div>
  )
}
